/**
 * Mocked live-streaming activity for the Live explore page.
 * Mix of currently-LIVE streams + upcoming stream events so the
 * mockups can show both the live tab and the auto-flip-to-live
 * scheduled events.
 */

export type MockStream = {
  streamerCallsign: string
  streamerDisplayName: string
  avatarUrl: string
  twitchLogin: string
  gameName: string
  streamTitle: string
  thumbnailUrl: string
  viewerCount: number
  startedHoursAgo: number
}

function dicebear(seed: string): string {
  return `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(seed)}&backgroundColor=11112A&textColor=3D6FFF`
}

/**
 * Static unsplash-style thumbnails. Picked deterministic stock IDs so
 * the same images load on every render; subjects are gaming-adjacent
 * (controller, monitor, headset) without showing any actual game
 * footage (avoids IP issues).
 */
const STREAM_THUMB_1 = 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=800&q=75'
const STREAM_THUMB_2 = 'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?auto=format&fit=crop&w=800&q=75'
const STREAM_THUMB_3 = 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=800&q=75'
const STREAM_THUMB_4 = 'https://images.unsplash.com/photo-1593305841991-05c297ba4575?auto=format&fit=crop&w=800&q=75'

export const MOCK_LIVE_STREAMS: MockStream[] = [
  {
    streamerCallsign: '@orion',
    streamerDisplayName: 'SGT Orion',
    avatarUrl: dicebear('Orion'),
    twitchLogin: 'orion_blk',
    gameName: 'Counter-Strike 2',
    streamTitle: 'Premier climb — ranked grind, BLACKLINE squad',
    thumbnailUrl: STREAM_THUMB_1,
    viewerCount: 247,
    startedHoursAgo: 1.4,
  },
  {
    streamerCallsign: '@stormbreaker',
    streamerDisplayName: 'Stormbreaker',
    avatarUrl: dicebear('Stormbreaker'),
    twitchLogin: 'stormbreaker_uk',
    gameName: 'Valorant',
    streamTitle: 'Diamond push · drops on',
    thumbnailUrl: STREAM_THUMB_2,
    viewerCount: 112,
    startedHoursAgo: 0.6,
  },
  {
    streamerCallsign: '@tempest',
    streamerDisplayName: 'Tempest',
    avatarUrl: dicebear('Tempest'),
    twitchLogin: 'tempest_rfp',
    gameName: 'Apex Legends',
    streamTitle: 'Trios with @paladin & @stormbreaker',
    thumbnailUrl: STREAM_THUMB_3,
    viewerCount: 89,
    startedHoursAgo: 0.3,
  },
  {
    streamerCallsign: '@vega',
    streamerDisplayName: 'CPL Vega',
    avatarUrl: dicebear('Vega'),
    twitchLogin: 'vega_atc',
    gameName: 'Rocket League',
    streamTitle: 'Diamond duels · push to GC',
    thumbnailUrl: STREAM_THUMB_4,
    viewerCount: 64,
    startedHoursAgo: 2.1,
  },
]
